// Sales formatting helpers (pure; shared by the screens and the PDF). Money and quantities are shown exactly as the
// database stored them (2 / 3 decimals); nothing here calculates an amount.
import { fmtAd, fmtBs } from "../lib/bs.js";       // explicit extensions: these pure modules are also run by Node in the PDF tests

// "1,25,000.00" (Nepali/Indian grouping), from a number or a numeric string.
export function npr(v) {
    const s = typeof v === "number" ? v.toFixed(2) : String(v ?? "0");
    const neg = s.startsWith("-");
    const [i, f = ""] = (neg ? s.slice(1) : s).split(".");
    const g = i.length > 3 ? i.slice(0, -3).replace(/\B(?=(\d{2})+$)/g, ",") + "," + i.slice(-3) : i;
    return `${neg ? "-" : ""}${g}.${(f + "00").slice(0, 2)}`;
}
// Quantity without trailing zeros: 1, 2.5, 0.333.
export const qty = (v) => String(Number(Number(v).toFixed(3)));
// Line discount as entered: "10%", "1,000.00" or "—".
export const discountLabel = (type, value) => (type === "percent" ? `${qty(value)}%` : type === "amount" ? npr(value) : "—");

// Today in Nepal (the database uses the same day for its date rules).
export const ktmToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kathmandu" }).format(new Date());
// Nepal calendar day ("YYYY-MM-DD") of a timestamp.
export const ktmDate = (ts) => (ts ? new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kathmandu" }).format(new Date(ts)) : null);
// Fiscal year (Shrawan–Ashadh) of an AD date from the verified calendar; null when its month isn't verified.
export function fyOf(iso, cal) {
    const b = iso ? cal?.adToBs(iso) : null;
    if (!b) return null;
    const y = b.m >= 4 ? b.y : b.y - 1;
    return `${y}/${String((y + 1) % 100).padStart(2, "0")}`;
}
// BS first, AD second (owner decision D7): "21 Ashwin 2083 (7 Oct 2026)".
export function dualDate(iso, cal) {
    if (!iso) return "—";
    const bs = fmtBs(cal?.adToBs(iso));
    return bs ? `${bs} (${fmtAd(iso)})` : `${fmtAd(iso)} (BS not available)`;
}
// Download name: no client name, no bank details.
export const pdfFileName = (docNo, suffix = "") => `Foxbeep-${String(docNo || "Quotation-draft").replace(/[^A-Za-z0-9-]+/g, "-")}${suffix}.pdf`;

// The PDF uses the standard Helvetica font (Windows-1252 characters). Text outside it (for example Devanagari) can't be
// printed correctly, so the screens check it before a quotation is issued.
const PRINTABLE = /^[\t\n\r\x20-\x7E -ÿ€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]*$/;
export const printable = (s) => PRINTABLE.test(String(s ?? ""));
// First [label, text] pair that the PDF can't print, or null.
export function unprintable(pairs) {
    return pairs.find(([, v]) => v != null && !printable(v)) || null;
}
